import {
  GET_EXCO_DOCUMENT,
  GET_EXCO_DOCUMENT_SUCCESS,
  GET_EXCO_DOCUMENT_FAIL,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAIL,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAIL,
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_SUCCESS,
  DOWNLOAD_FAIL,
  GET_PROVINSI,
  GET_PROVINSI_SUCCESS,
  GET_PROVINSI_FAIL,
  GET_KABKOT,
  GET_KABKOT_SUCCESS,
  GET_KABKOT_FAIL,
  GET_KECAMATAN,
  GET_KECAMATAN_SUCCESS,
  GET_KECAMATAN_FAIL,
  GET_KELURAHAN,
  GET_KELURAHAN_SUCCESS,
  GET_KELURAHAN_FAIL,
  GET_TINGKAT_EXCO,
  GET_TINGKAT_EXCO_SUCCESS,
  GET_TINGKAT_EXCO_FAIL,
  GET_JABATAN,
  GET_JABATAN_SUCCESS,
  GET_JABATAN_FAIL,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAIL,
  UPDATE_PHONENUMBER,
  UPDATE_PHONENUMBER_SUCCESS,
  UPDATE_PHONENUMBER_FAIL,
  GET_ANGGOTA,
  GET_ANGGOTA_SUCCESS,
  GET_ANGGOTA_FAIL,
  GET_BANK,
  GET_BANK_SUCCESS,
  GET_BANK_FAIL,
  UPLOAD_DOCUMENT_PENGURUS,
  UPLOAD_DOCUMENT_PENGURUS_SUCCESS,
  UPLOAD_DOCUMENT_PENGURUS_FAIL,
  DELETE_DOCUMENT_PENGURUS,
  DELETE_DOCUMENT_PENGURUS_SUCCESS,
  DELETE_DOCUMENT_PENGURUS_FAIL,
  DOWNLOAD_DOCUMENT_PENGURUS,
  DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS,
  DOWNLOAD_DOCUMENT_PENGURUS_FAIL,
  DOWNLOAD_HISTORY_DOCUMENT,
  DOWNLOAD_HISTORY_DOCUMENT_SUCCESS,
  DOWNLOAD_HISTORY_DOCUMENT_FAIL,
  LIST_HISTORY_DOCUMENT,
  LIST_HISTORY_DOCUMENT_SUCCESS,
  LIST_HISTORY_DOCUMENT_FAIL,
  GET_CATATAN,
  GET_CATATAN_SUCCESS,
  GET_CATATAN_FAIL
} from "./actionTypes";

const initialState = {
  dataExcoDocument: {
    loading: false,
    error: false,
    data: null,
  },
  uploadDocument: {
    loading: false,
    error: false,
    data: null,
  },
  deleteDocument: {
    loading: false,
    error: false,
    data: null,
  },
  downloadDocument: {
    loading: false,
    error: false,
    data: null,
  },
  dataProvince: {
    loading: false,
    error: false,
    data: null,
  },
  dataKabKot: {
    loading: false,
    error: false,
    data: null,
  },
  dataKecamatan: {
    loading: false,
    error: false,
    data: null,
  },
  dataKelurahan: {
    loading: false,
    error: false,
    data: null,
  },
  dataTingkatExco: {
    loading: false,
    error: false,
    data: null,
  },
  dataJabatan: {
    loading: false,
    error: false,
    data: null,
  },
  dataProfile: {
    loading: false,
    error: false,
    data: null,
  },
  changePassword: {
    loading: false,
    error: false,
    data: null,
  },
  changePhoneNumber: {
    loading: false,
    error: false,
    data: null,
  },
  dataAnggota: {
    loading: false,
    error: false,
    data: null,
  },
  dataBank: {
    loading: false,
    error: false,
    data: null,
  },
  uploadDocumentPengurus: {
    loading: false,
    error: false,
    data: null,
  },
  deleteDocumentPengurus: {
    loading: false,
    error: false,
    data: null,
  },
  downloadDocumentPengurus: {
    loading: false,
    error: false,
    data: null,
  },
  listHistoryDokumen: {
    loading: false,
    error: false,
    data: null,
  },
  downloadHistoryDokumen: {
    loading: false,
    error: false,
    data: null,
  },
  dataCatatan: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // get all documents
    case GET_EXCO_DOCUMENT:
      return {
        ...state,
        dataExcoDocument: {
          ...state.dataExcoDocument,
          loading: true,
          error: false,
        },
      };
    case GET_EXCO_DOCUMENT_SUCCESS:
      return {
        ...state,
        dataExcoDocument: {
          ...state.dataExcoDocument,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_EXCO_DOCUMENT_FAIL:
      return {
        ...state,
        dataExcoDocument: {
          ...state.dataExcoDocument,
          loading: false,
          error: action.payload,
        },
      };

    // upload documents
    case UPLOAD_DOCUMENT:
      return {
        ...state,
        uploadDocument: {
          ...state.uploadDocument,
          loading: true,
          error: false,
        },
      };
    case UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadDocument: {
          ...state.uploadDocument,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case UPLOAD_DOCUMENT_FAIL:
      return {
        ...state,
        uploadDocument: {
          ...state.uploadDocument,
          loading: false,
          error: action.payload,
        },
      };
    // delete documents
    case DELETE_DOCUMENT:
      return {
        ...state,
        deleteDocument: {
          ...state.deleteDocument,
          loading: true,
          error: false,
        },
      };
    case DELETE_DOCUMENT_SUCCESS:
      return {
        ...state,
        deleteDocument: {
          ...state.deleteDocument,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case DELETE_DOCUMENT_FAIL:
      return {
        ...state,
        deleteDocument: {
          ...state.deleteDocument,
          loading: false,
          error: action.payload,
        },
      };
    // download documents
    case DOWNLOAD_DOCUMENT:
      return {
        ...state,
        downloadDocument: {
          ...state.downloadDocument,
          loading: true,
          error: false,
        },
      };
    case DOWNLOAD_SUCCESS:
      return {
        ...state,
        downloadDocument: {
          ...state.downloadDocument,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case DOWNLOAD_FAIL:
      return {
        ...state,
        downloadDocument: {
          ...state.downloadDocument,
          loading: false,
          error: action.payload,
        },
      };
    // get province
    case GET_PROVINSI:
      return {
        ...state,
        dataProvince: {
          ...state.dataProvince,
          loading: true,
          error: false,
        },
      };
    case GET_PROVINSI_SUCCESS:
      return {
        ...state,
        dataProvince: {
          ...state.dataProvince,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_PROVINSI_FAIL:
      return {
        ...state,
        dataProvince: {
          ...state.dataProvince,
          loading: false,
          error: action.payload,
        },
      };
    // get kabkot
    case GET_KABKOT:
      return {
        ...state,
        dataKabKot: {
          ...state.dataKabKot,
          loading: true,
          error: false,
        },
      };
    case GET_KABKOT_SUCCESS:
      return {
        ...state,
        dataKabKot: {
          ...state.dataKabKot,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_KABKOT_FAIL:
      return {
        ...state,
        dataKabKot: {
          ...state.dataKabKot,
          loading: false,
          error: action.payload,
        },
      };
    // get kecamatan
    case GET_KECAMATAN:
      return {
        ...state,
        dataKecamatan: {
          ...state.dataKecamatan,
          loading: true,
          error: false,
        },
      };
    case GET_KECAMATAN_SUCCESS:
      return {
        ...state,
        dataKecamatan: {
          ...state.dataKecamatan,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_KECAMATAN_FAIL:
      return {
        ...state,
        dataKecamatan: {
          ...state.dataKecamatan,
          loading: false,
          error: action.payload,
        },
      };
    // get kelurahan
    case GET_KELURAHAN:
      return {
        ...state,
        dataKelurahan: {
          ...state.dataKelurahan,
          loading: true,
          error: false,
        },
      };
    case GET_KELURAHAN_SUCCESS:
      return {
        ...state,
        dataKelurahan: {
          ...state.dataKelurahan,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_KELURAHAN_FAIL:
      return {
        ...state,
        dataKelurahan: {
          ...state.dataKelurahan,
          loading: false,
          error: action.payload,
        },
      };
    // get tingkat exco
    case GET_TINGKAT_EXCO:
      return {
        ...state,
        dataTingkatExco: {
          ...state.dataTingkatExco,
          loading: true,
          error: false,
        },
      };
    case GET_TINGKAT_EXCO_SUCCESS:
      return {
        ...state,
        dataTingkatExco: {
          ...state.dataTingkatExco,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_TINGKAT_EXCO_FAIL:
      return {
        ...state,
        dataTingkatExco: {
          ...state.dataTingkatExco,
          loading: false,
          error: action.payload,
        },
      };
    // get jabatan
    case GET_JABATAN:
      return {
        ...state,
        dataJabatan: {
          ...state.dataJabatan,
          loading: true,
          error: false,
        },
      };
    case GET_JABATAN_SUCCESS:
      return {
        ...state,
        dataJabatan: {
          ...state.dataJabatan,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_JABATAN_FAIL:
      return {
        ...state,
        dataJabatan: {
          ...state.dataJabatan,
          loading: false,
          error: action.payload,
        },
      };
    // get profile
    case GET_PROFILE:
      return {
        ...state,
        dataProfile: {
          ...state.dataProfile,
          loading: true,
          error: false,
        },
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        dataProfile: {
          ...state.dataProfile,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_PROFILE_FAIL:
      return {
        ...state,
        dataProfile: {
          ...state.dataProfile,
          loading: false,
          error: action.payload,
        },
      };
    // change password
    case UPDATE_PASSWORD:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: true,
          error: false,
        },
      };
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case UPDATE_PASSWORD_FAIL:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: false,
          error: action.payload,
        },
      };

    // change phonenumber
    case UPDATE_PHONENUMBER:
      return {
        ...state,
        changePhoneNumber: {
          ...state.changePhoneNumber,
          loading: true,
          error: false,
        },
      };
    case UPDATE_PHONENUMBER_SUCCESS:
      return {
        ...state,
        changePhoneNumber: {
          ...state.changePhoneNumber,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case UPDATE_PHONENUMBER_FAIL:
      return {
        ...state,
        changePhoneNumber: {
          ...state.changePhoneNumber,
          loading: false,
          error: action.payload,
        },
      };
    // get anggota
    case GET_ANGGOTA:
      return {
        ...state,
        dataAnggota: {
          ...state.dataAnggota,
          loading: true,
          error: false,
        },
      };
    case GET_ANGGOTA_SUCCESS:
      return {
        ...state,
        dataAnggota: {
          ...state.dataAnggota,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_ANGGOTA_FAIL:
      return {
        ...state,
        dataAnggota: {
          ...state.dataAnggota,
          loading: false,
          error: action.payload,
        },
      };
    // get anggota
    case GET_BANK:
      return {
        ...state,
        dataBank: {
          ...state.dataBank,
          loading: true,
          error: false,
        },
      };
    case GET_BANK_SUCCESS:
      return {
        ...state,
        dataBank: {
          ...state.dataBank,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_BANK_FAIL:
      return {
        ...state,
        dataBank: {
          ...state.dataBank,
          loading: false,
          error: action.payload,
        },
      };
      case UPLOAD_DOCUMENT_PENGURUS:
        return {
          ...state,
          uploadDocumentPengurus: {
            ...state.uploadDocumentPengurus,
            loading: true,
            error: false,
          },
        };
      case UPLOAD_DOCUMENT_PENGURUS_SUCCESS:
        return {
          ...state,
          uploadDocumentPengurus: {
            ...state.uploadDocumentPengurus,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case UPLOAD_DOCUMENT_PENGURUS_FAIL:
        return {
          ...state,
          uploadDocumentPengurus: {
            ...state.uploadDocumentPengurus,
            loading: false,
            error: action.payload,
          },
        };
      // delete documents
      case DELETE_DOCUMENT_PENGURUS:
        return {
          ...state,
          deleteDocumentPengurus: {
            ...state.deleteDocumentPengurus,
            loading: true,
            error: false,
          },
        };
      case DELETE_DOCUMENT_PENGURUS_SUCCESS:
        return {
          ...state,
          deleteDocumentPengurus: {
            ...state.deleteDocumentPengurus,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case DELETE_DOCUMENT_PENGURUS_FAIL:
        return {
          ...state,
          deleteDocumentPengurus: {
            ...state.deleteDocumentPengurus,
            loading: false,
            error: action.payload,
          },
        };
      // download documents
      case DOWNLOAD_DOCUMENT_PENGURUS:
        return {
          ...state,
          downloadDocumentPengurus: {
            ...state.downloadDocumentPengurus,
            loading: true,
            error: false,
          },
        };
      case DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS:
        return {
          ...state,
          downloadDocumentPengurus: {
            ...state.downloadDocumentPengurus,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case DOWNLOAD_DOCUMENT_PENGURUS_FAIL:
        return {
          ...state,
          downloadDocumentPengurus: {
            ...state.downloadDocumentPengurus,
            loading: false,
            error: action.payload,
          },
        };
      // list history documents
      case LIST_HISTORY_DOCUMENT:
        return {
          ...state,
          listHistoryDokumen: {
            ...state.listHistoryDokumen,
            loading: true,
            error: false,
          },
        };
      case LIST_HISTORY_DOCUMENT_SUCCESS:
        return {
          ...state,
          listHistoryDokumen: {
            ...state.listHistoryDokumen,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case LIST_HISTORY_DOCUMENT_FAIL:
        return {
          ...state,
          listHistoryDokumen: {
            ...state.listHistoryDokumen,
            loading: false,
            error: action.payload,
          },
        };
      // download history documents
      case DOWNLOAD_HISTORY_DOCUMENT:
        return {
          ...state,
          downloadHistoryDokumen: {
            ...state.downloadHistoryDokumen,
            loading: true,
            error: false,
          },
        };
      case DOWNLOAD_HISTORY_DOCUMENT_SUCCESS:
        return {
          ...state,
          downloadHistoryDokumen: {
            ...state.downloadHistoryDokumen,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case DOWNLOAD_HISTORY_DOCUMENT_FAIL:
        return {
          ...state,
          downloadHistoryDokumen: {
            ...state.downloadHistoryDokumen,
            loading: false,
            error: action.payload,
          },
        };
      // get catatan
      case GET_CATATAN:
        return {
          ...state,
          dataCatatan: {
            ...state.dataCatatan,
            loading: true,
            error: false,
          },
        };
      case GET_CATATAN_SUCCESS:
        return {
          ...state,
          dataCatatan: {
            ...state.dataCatatan,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_CATATAN_FAIL:
        return {
          ...state,
          dataCatatan: {
            ...state.dataCatatan,
            loading: false,
            error: action.payload,
          },
        };
    default:
      return state;
  }
};

export default reducer;
